<template>
  <div id="lwi-signup">
    <ProgrammeSignup
      :title="title"
      :programmeCode="programmeCode"
      :ctaButton="ctaButton"
      :themeColor="themeColor"
      :sale="sale"
      logo="/assets/images/launch-with-intention-logo.svg"
    >
      <template v-slot:sidebar>
        <div class="included mt-5 mt-lg-0">
          <h2>The Launch with Intention Program includes:</h2>
          <div
            v-for="(included, index) in includedContent"
            :key="index"
            class="smaller py-2"
          >
            <i class="fa fa-check c-lwi mr-2"></i>
            <span v-if="included.bonus" class="bonus mr-2">{{
              included.bonus
            }}</span>
            <span>{{ included.description }}</span>
          </div>
        </div>
        <!--        <div class="included mt-5">-->
        <!--          <h5>With Marvelous Software you get:</h5>-->
        <!--          <div-->
        <!--            v-for="(included, index) in marvelousIncludedContent"-->
        <!--            :key="index"-->
        <!--            class="smaller py-2"-->
        <!--          >-->
        <!--            <i class="fa fa-check c-lwi mr-2"></i>-->
        <!--            <span v-if="included.bonus" class="bonus mr-2">{{-->
        <!--              included.bonus-->
        <!--            }}</span>-->
        <!--            <span>{{ included.description }}</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="included mt-5">
          <h2>Privacy</h2>
          <p class="smaller mt-3">
            We will not share or trade online information that you provide us
            (including e-mail addresses).
          </p>
          <span>
            <i class="fal fa-user-shield c-lwi mr-2"></i>
            <span class="smaller c-dark-gray">Your privacy is protected</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Security</h2>
          <p class="smaller mt-3">
            All personal information you submit is encrypted and secure.
          </p>
          <span>
            <i class="fal fa-lock-alt c-lwi mr-2"></i>
            <span class="smaller c-dark-gray">Your information is secure</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Need help?</h2>
          <div class="small mt-3">
            Email:
            <a href="mailto:team@heymarvelous.com" class="c-lwi"
              >team@heymarvelous.com</a
            >
          </div>
        </div>
      </template>
    </ProgrammeSignup>
  </div>
</template>

<script>
import ProgrammeSignup from '@/web/views/admin/ProgrammeSignup';
export default {
  name: 'LWIProgrammeSignup',
  components: { ProgrammeSignup },
  props: {
    title: {
      type: String,
      default: null,
    },
    programmeCode: {
      type: String,
      default: null,
    },
    ctaButton: {
      type: String,
      default: 'SIGNUP.BUTTON.GET_STARTED',
    },
    themeColor: {
      type: String,
      default: 'lwi',
    },
    sale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    includedContent() {
      return [
        {
          description: 'Launch with Intention Course (Value $1,997)',
        },
        {
          bonus: 'BONUS:',
          description:
            '40-Day Social Media Marketing with Intention course (Value $199)',
        },
        {
          bonus: 'BONUS:',
          description: 'Film School (Value $199)',
        },
        {
          bonus: 'BONUS:',
          description:
            '1-Year Subscription to Pro Plan of Marvelous Software (Value $1,790)',
        },
        {
          bonus: 'TOTAL VALUE OVER',
          description: '$4,000',
        },
      ];
    },
    // marvelousIncludedContent() {
    //   return [
    //     {
    //       description:
    //         '1-Year Subscription to Pro Plan of Marvelous Software (Value $1,790)',
    //     },
    //     {
    //       description: 'Film School (Value $199)',
    //     },
    //     {
    //       bonus: 'TOTAL VALUE OVER',
    //       description: '$7,000',
    //     },
    //   ];
    // },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Work+Sans&display=swap');

@font-face {
  font-family: 'ivy_modelight';
  src: url('~@/assets/fonts/ivymode-light-webfont.woff2') format('woff2'),
    url('~@/assets/fonts/ivymode-light-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

#lwi-signup {
  font-family: 'Work Sans', sans-serif;

  h1,
  h2,
  h3 {
    font-family: 'ivy_modelight';
  }

  a {
    color: $lwi-color !important;
  }
}

.included {
  color: $black;
  line-height: 26px;

  h2 {
    color: $dark-gray;
  }

  .bonus {
    text-transform: uppercase;
    color: $lwi-color;
  }
}
</style>
